import React, { useEffect, useState } from 'react';
import '../../../../scss/common/inputs.scss';
import { observer } from 'mobx-react';
const TextInput = observer(({
  title,
  description,
  required,
  type = 'text',
  maxChars = -1,
  // unlimited
  disabled,
  onTextChange = null,
  defaultValue = '',
  placeholder = '',
  showMode = false,
  minValue,
  maxValue,
  validationFieldsNames = [],
  validatorErrors = []
}) => {
  const [value, setValue] = useState(defaultValue);
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);
  const onChange = newText => {
    if (showMode) {
      return;
    }
    if (type === 'number') {
      if (typeof minValue !== 'undefined') {
        const currentValue = parseInt(newText);
        if (currentValue < minValue) {
          return;
        }
      }
      if (typeof maxValue !== 'undefined') {
        const currentValue = parseInt(newText);
        if (currentValue > maxValue) {
          return;
        }
      }
    }
    setValue(newText);
    if (onTextChange) {
      onTextChange(newText);
    }
  };
  let invalidInput = validatorErrors && validatorErrors.filter(e => validationFieldsNames.includes(e.field)).length > 0;
  return /*#__PURE__*/React.createElement("div", {
    className: `cms-input cms-text-input-container ${invalidInput ? 'invalid-input' : ''}`
  }, title ? /*#__PURE__*/React.createElement("div", {
    className: "cms-input-title text-input-container"
  }, title, required ? '*' : '') : null, description ? /*#__PURE__*/React.createElement("div", {
    className: "cms-input-description cms-file-input-description"
  }, description, " ", maxChars !== -1 ? `(max ${maxChars} ${type === 'text' ? 'lettere' : 'cifre'})` : ``) : null, /*#__PURE__*/React.createElement("input", {
    disabled: disabled || showMode,
    type: type,
    value: showMode ? defaultValue : value,
    placeholder: placeholder,
    onChange: e => onChange(e.target.value),
    maxLength: maxChars
  }));
});
export default TextInput;